<template lang="pug">
	.audio-tracker-button-group.flex-row
		slot
</template>


<script>
	export default {
		translationCategory: 'audioTracker.AudioTrackerButton',
		name: 'audio-tracker-button-group',
		components: { }
	}
</script>
<style lang='scss'>
	@import "main/themes/generated/variables.base.scss";
	.audio-tracker-button-group {
		.audio-tracker-button:first-child:not(:last-child) {
			border-top-right-radius: 0px;
			border-bottom-right-radius: 0px;
			border-right-width: 0px;
		}

		.audio-tracker-button:last-child:not(:first-child) {
			border-top-left-radius: 0px;
			border-bottom-left-radius: 0px;
			border-left-color: #eee;
		}

		.audio-tracker-button:not(:last-child):not(:first-child) {
			border-top-right-radius: 0px;
			border-bottom-right-radius: 0px;
			border-top-left-radius: 0px;
			border-bottom-left-radius: 0px;
			border-right-width: 0px;
			border-left-color: #eee;
		}
	}
</style>
